import { useTenantConfig } from '../context/useTenantConfig';

const TIER_LABEL: Record<string, string> = {
  free: 'Free',
  standard: 'Standard',
  premium: 'Premium',
};

export function BrandHeader() {
  const config = useTenantConfig();
  const { branding, displayName, tagline, tier } = config;

  return (
    <header
      className="w-full bg-brand-accent text-brand-accent-fg shadow-sm"
      role="banner"
      aria-label={`${displayName} header`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <div className="flex items-center gap-3 min-w-0">
          {branding.logoUrl ? (
            <img
              src={branding.logoUrl}
              alt=""
              className="h-8 w-8 rounded"
              aria-hidden="true"
            />
          ) : (
            <span className="text-2xl leading-none" aria-hidden="true">
              {branding.logoGlyph}
            </span>
          )}
          <div className="min-w-0">
            <div className="font-semibold text-base truncate">{displayName}</div>
            {tagline ? (
              <div className="text-xs opacity-80 truncate">{tagline}</div>
            ) : null}
          </div>
        </div>

        <span className="text-[10px] font-semibold tracking-wide uppercase px-2 py-1 rounded-full bg-white/15 ring-1 ring-white/20">
          {TIER_LABEL[tier] ?? tier}
        </span>
      </div>
    </header>
  );
}
